import graphql__6d5e041d30bc2b8c453b from "./__generated__/ContributionModalReactions_contribution.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";

import ReactableMeasures from "../ParticipativeModule/Visualizations/ReactableMeasures";
import ContributionBookmarkButton from "../ParticipativeModule/Visualizations/ContributionBookmarkButton";
import VoteButtons from "../Votable/VoteButtons";
import { isUnauthorized } from "../Utils/authorizations";
import { useFormatMessage } from "../Intl/Context";

const ContributionModalReactions = props => {
  const contribution = useFragment(
    ContributionModalReactions_contribution,
    props.contribution
  );
  const {
    votesDisplayAuthorized,
    votesSubmissionAuthorized,
    bookmarksCreationAuthorized
  } = contribution.authorizations;

  const votesDisplayAllowed = !isUnauthorized(votesDisplayAuthorized);
  const votesSubmissionAllowed = !isUnauthorized(votesSubmissionAuthorized);
  const displayMeasures = votesDisplayAllowed && !votesSubmissionAllowed;
  const displayVoteButtons = votesDisplayAllowed && votesSubmissionAllowed;
  const displayBookmarkButton = !isUnauthorized(bookmarksCreationAuthorized);

  const t = useFormatMessage();
  const signInToBookmark = t(intlMessages.signInToBookmark);

  const currentUrl = props.location || window.location;
  const bookmarkUrl = [currentUrl.pathname, "bookmark"].join("#");

  if (!displayMeasures && !displayVoteButtons && !displayBookmarkButton) return null;

  return (
    <div className="d-flex align-items-center">
      {displayMeasures && (
        <ReactableMeasures
          reactable={contribution}
          hideComments
          className="nowrap margin-right-xs"
        />
      )}

      {displayVoteButtons && (
        <VoteButtons
          votable={contribution}
          className="nowrap vote-buttons-inline contribution-vote-buttons vizualization-contribution-votes margin-right-xs"
        />
      )}

      {displayBookmarkButton && (
        <div>
          <ContributionBookmarkButton
            contribution={contribution}
            actionURI={bookmarkUrl}
            signInMessage={signInToBookmark}
            authorization={bookmarksCreationAuthorized}
            disabledAriaLabel
          />
        </div>
      )}
    </div>
  );
};

const ContributionModalReactions_contribution = graphql__6d5e041d30bc2b8c453b;

export default ContributionModalReactions;

const intlMessages = defineMessages({
  signInToBookmark: {
    id: "contributions.modal.signInToBookmark",
    defaultMessage: `
      Vous devez vous connecter ou créer un compte afin de pouvoir ajouter
      la proposition à vos favoris.
    `
  }
});
